import {
  useGetQuotaLimit,
  useGetQuotaLimitAPIKey,
} from '@/service/quota-limit/hook';
import TableLLMAPIKey from './table-llm-api-key';
import ProgressUsage from './progress-usage';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import TableInstance from './table-instance';

const ServiceQuota = () => {
  const quotaLimitAPIKey = useGetQuotaLimitAPIKey();
  const { data } = useGetQuotaLimit();

  return (
    <>
      <div className="container flex flex-col gap-3">
        <p className="text-xl font-semibold">Service Quota</p>
        <div className="flex flex-col divide-y *:py-6 first:*:pt-0 last:*:pb-0">
          <div className="">
            <span className="text-base font-medium">LLM as a service</span>
            <div className="mt-3 max-w-[340px]">
              <ProgressUsage
                label="API Key"
                used={data?.llm_api_key?.using || 0}
                total={data?.llm_api_key?.max || 0}
              />
            </div>
            <div>
              <Accordion type="single" collapsible className="w-full">
                <AccordionItem value="item-1">
                  <AccordionTrigger>Show</AccordionTrigger>
                  <AccordionContent>
                    <TableLLMAPIKey
                      data={
                        quotaLimitAPIKey?.data?.result?.map((e) => ({
                          id: e.id,
                          name: e.api_key_name || '',
                          apiKey: e.api_key || '',
                          createDate: e.create_date || '',
                          workspaceId: e.workspace_id || '',
                        })) || []
                      }
                      isLoading={quotaLimitAPIKey?.isLoading}
                    />
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>
          </div>
        </div>
        <div className="mt-8 flex flex-col divide-y *:py-6 first:*:pt-0 last:*:pb-0">
          <div className="">
            <span className="text-base font-medium">One click deploy</span>
            <div className="mt-3 max-w-[340px]">
              <ProgressUsage
                label="GPU Card"
                used={data?.on_click_deploy?.using || 0}
                total={data?.on_click_deploy?.max || 0}
              />
            </div>
            {/* <div>
              <Accordion type="single" collapsible className="w-full">
                <AccordionItem value="item-1">
                  <AccordionTrigger>Show</AccordionTrigger>
                  <AccordionContent>
                    <TableInstance />
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div> */}
          </div>
        </div>
        <div className="mt-8 flex flex-col divide-y *:py-6 first:*:pt-0 last:*:pb-0">
          <div className="">
            <span className="text-base font-medium">Serverless GPU</span>
            <div className="mt-3 max-w-[340px]">
              <ProgressUsage
                label="Project"
                used={data?.serverless_gpu?.project?.using || 0}
                total={data?.serverless_gpu?.project?.max || 0}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ServiceQuota;
